import type { SpartanProductAdasData } from '@/app/lcv/components/sections/spartan/products/adas/types';
import { SPARTAN_PRODUCT_EXPLORE_FEATURES_ADAS_ID } from '@/app/lcv/components/sections/spartan/products/explore-features/constants';
import type {
  SpartanProductExploreFeaturesDetailData,
  SpartanProductExploreFeaturesFeature,
} from '@/app/lcv/components/sections/spartan/products/explore-features/types';
import { mapSpartanAdasToExploreDetail } from '@/app/lcv/components/sections/spartan/products/explore-features/utils';

export const SPARTAN_PRODUCT_EXPLORE_FEATURES_ADAS_CARD = {
  id: SPARTAN_PRODUCT_EXPLORE_FEATURES_ADAS_ID,
  eyebrow: 'ระบบช่วยเหลือผู้ขับขี่',
  title: 'ADAS',
} as const satisfies Pick<
  SpartanProductExploreFeaturesFeature,
  'id' | 'eyebrow' | 'title'
>;

export const buildSpartanExploreFeaturesAdasCard = (
  imageSrc: string,
  cardOverlayColor?: string
): SpartanProductExploreFeaturesFeature => ({
  ...SPARTAN_PRODUCT_EXPLORE_FEATURES_ADAS_CARD,
  image: { src: imageSrc },
  ...(cardOverlayColor ? { cardOverlayColor } : {}),
});

export const buildSpartanExploreFeaturesAdasDetail = (
  adas: SpartanProductAdasData,
  imageCover: { mobile: string; desktop: string }
): SpartanProductExploreFeaturesDetailData =>
  mapSpartanAdasToExploreDetail(adas, imageCover);
